<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 7H8M16 11H8M13 15H8M4 22L6 21L8 22L10 21L12 22L14 21L16 22L18 21L20 22V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V22Z"
      stroke="#6b7280"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
